
/* eslint-disable import/no-mutable-exports */
var warning = function warning() {
  return true;
};

if (process.env.NODE_ENV !== 'production') {
  warning = function warning(condition, message) {
    if (!condition) {
      if (typeof console !== 'undefined') {
        console.error(message); // eslint-disable-line
      }
    }
  };
}

export default warning;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/warning.js
// module id = 283
// module chunks = 0